import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Events from "../Home/Events";
import Decision from "../Components/Decision";

export default function EventsPage() {
    return (
      <div>
        <Header />
        <Events />
        <Decision/>
        <Footer />
      </div>
    );
  }